// extracted by mini-css-extract-plugin
export default {"gallery":"c-o_fG","gallery__header":"c-o_fH","gallery__thumbs":"c-o_fJ"};